
import { getExportedData } from '../../../modules/ExportData/store/actions'

export const exportData = {
  view: {
    get: getExportedData,
  },
}
